import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";

export default function BuyerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.BUYING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.buyerGuide();

  const toggleAccordion = (index) => {
    const temp = [...open];
    temp[index] = !temp[index];
    setOpen(temp);
  };

  return (
    <>
      <SEO {...seoConfig} />

      <section className="bg-summit-background min-h-screen pt-40 pb-20">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="max-w-5xl mx-auto px-6">

          {/* Heading */}
          <div className="text-center mb-14">
            <motion.p
              variants={fadeUp}
              className="uppercase tracking-[5px] text-summit-highlight text-sm font-medium">
              Helpful Resources
            </motion.p>

            <motion.h1
              variants={fadeUp}
              className="font-heading text-5xl md:text-6xl text-summit-primary mt-4">
              Buyer's Guide
            </motion.h1>

            <motion.div
              variants={fadeUp}
              className="w-20 h-1 bg-summit-highlight mx-auto mt-6 rounded-full"></motion.div>

            <motion.p
              variants={fadeUp}
              className="max-w-2xl mx-auto mt-6 text-summit-muted leading-8 font-body">
              Everything you need to know before purchasing your next home.
              Browse through the guide below to better understand each step of
              the buying journey.
            </motion.p>
          </div>

          {/* Accordion */}
          <div className="space-y-5">
            {constants.BUYING_GUIDE.map((guide, index) => (
              <motion.div
                variants={fadeUp}
                key={index}
                className="rounded-2xl overflow-hidden bg-white shadow-sm border border-summit-background hover:shadow-lg transition-all duration-300"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex justify-between items-center px-8 py-6 text-left group"
                >
                  <div className="flex items-center gap-5">
                    <div className="w-1 self-stretch rounded-full bg-summit-highlight"></div>

                    <h2 className="font-heading text-2xl text-summit-primary group-hover:text-summit-secondary transition">
                      {guide.heading}
                    </h2>
                  </div>

                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className={`text-summit-highlight text-xl transition-transform duration-300 ${open[index] ? "rotate-180" : ""
                      }`}
                  />
                </button>

                <div
                  className={`grid transition-all duration-500 ease-in-out ${open[index]
                    ? "grid-rows-[1fr]"
                    : "grid-rows-[0fr]"
                    }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-8 pb-8 text-summit-tertiary leading-8 font-body">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: guide.text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

        </motion.div>
      </section>
    </>
  );
}